import { actionTypes } from '../actions/onboarding';
import { onboarding as defaultState } from './default.json';
import { getInstruments } from '../utils/quiz-utils';

const handlers = {
  [actionTypes.ONBOARDING_GET_PATHS_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.ONBOARDING_GET_PATHS_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    inProgress: false,
    instruments: getInstruments(action.results.items),
    pathList: action.results.items,
  }),
  [actionTypes.ONBOARDING_GET_PATHS_ERROR]: (state, action) => ({
    ...state,
    error: action.error.message,
    inProgress: false,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
